import { request } from '@/utils/ajax';
import { getShowroomConfiguratorVisualization } from '@/services/showroom/showroom.api';
import { ConfiguratorVisualizationRoomDto } from './configurator-visualization.types';

export function getConfiguratorVisualization(
    residentialUnitId: number,
    options?: { showroomPath?: string | null }
): Promise<ConfiguratorVisualizationRoomDto[]> {
    // Anonymous showroom: route through the path-scoped public endpoint (mirrors the showroom image
    // URLs), which needs no auth. Otherwise use the auth-gated per-unit endpoint.
    if (options?.showroomPath) {
        return getShowroomConfiguratorVisualization(options.showroomPath);
    }
    return request(`api/configurator-visualization/${residentialUnitId}`).then((x) => x.json());
}
